/** The signed-in customer's own profile (auth_handler's me.rs). */
import { api } from './client';

export type Theme = 'light' | 'dark';

export interface Profile {
  customer_id: string;
  email: string | null;
  name: string | null;
  /** A null theme means follow the device. */
  preferences: { theme: Theme | null };
}

export const me = {
  get: () => api.get<Profile>('/api/v1/me'),
  /** Save the customer's theme; null goes back to following the device. */
  setTheme: (theme: Theme | null) => api.patch<{ theme: Theme | null }>('/api/v1/me/preferences', { theme }),
};
